export const APPROVE_DISCOUNT_START = 'APPROVE_DISCOUNT_START';
export const APPROVE_DISCOUNT_SUCCESS = 'APPROVE_DISCOUNT_SUCCESS';
export const APPROVE_DISCOUNT_ERROR = 'APPROVE_DISCOUNT_ERROR';
export const CANCEL_TRADE_START = 'CANCEL_TRADE_START';
export const CANCEL_TRADE_SUCCESS = 'CANCEL_TRADE_SUCCESS';
export const CANCEL_TRADE_ERROR = 'CANCEL_TRADE_ERROR';
export const NEW_PAYMENT_DATA_RECEIVED = 'NEW_PAYMENT_DATA_RECEIVED';
export const SUGGEST_DISCOUNT_START = 'SUGGEST_DISCOUNT_PAYMENT_START';
export const SUGGEST_DISCOUNT_SUCCESS = 'SUGGEST_DISCOUNT_SUCCESS';
export const SUGGEST_DISCOUNT_ERROR = 'SUGGEST_DISCOUNT_PAYMENT_ERROR';



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/paymentActionTypes.js